/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const EmailTemplateType = createEnum('EMAIL_TEMPLATE_TYPE', {
  System: '1',
  Job: '2',
  Internal: '3',
  Layout: '4',
});
export type EmailTemplateType = EnumSet<typeof EmailTemplateType>;

export const EMAIL_TEMPLATE_SYSTEM_TYPE = 'System';
export const EMAIL_TEMPLATE_JOB_TYPE = 'Job';
export const EMAIL_TEMPLATE_INTERNAL_TYPE = 'Internal';
export const EMAIL_TEMPLATE_LAYOUT_TYPE = 'Layout';
